import { View } from "react-native";
import { Chip, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { Option } from "../../types";

type Props = {
  options: Option[];
  removeOption: (option: Option) => void;
};

export default function OptionChips({ options, removeOption }: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();
  return (
    <View style={tailwind("flex-row flex-wrap mt-3")}>
      {options.map((option, index) => (
        <View key={index} style={tailwind("mr-1 mt-1")}>
          <Chip
            onClose={() => removeOption(option)}
            style={{ backgroundColor: colors.tertiaryContainer }}
            selectedColor={colors.onTertiaryContainer}
          >
            {option.name}
          </Chip>
        </View>
      ))}
    </View>
  );
}
